import React from "react";
import { FaFacebook, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const handleWhatsappClick = () => {
    window.open("https://wa.me/551148633465", "_blank");
  };

  return (
    <div className="w-screen px-[20px] lg:px-[120px] py-16 pb-[10rem] bg-terciary-color justify-center items-center gap-2.5 flex">
      <div className="w-full max-w-[85rem] justify-center items-center gap-5 flex flex-col lg:flex-row">
        <div className="w-full max-w-[85rem] px-6 mx-auto flex justify-center lg:justify-start items-start gap-6">
          <a
            href="https://www.tim.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity duration-200"
            aria-label="Logo TIM"
          >
            <img
              src="/tim/images/logos/logo-tim.png"
              alt="Logo TIM"
              width={90}
              height={30}
            />
          </a>

          <a
            href="https://thopenergy.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity duration-200"
            aria-label="Logo Thopen"
          >
            <img
              src="/tim/images/logo_topen_white.png"
              alt="Logo Thopen"
              width={110}
              height={30}
            />
          </a>
        </div>

        <div className="w-full justify-center md:justify-start items-center gap-10 flex">
          <a
            href="https://www.facebook.com/thopenergy/"
            className="hover:opacity-80"
            target="_blank"
            rel="noopener noreferrer"
            alt="Facebook"
            aria-label="Facebook"
          >
            <FaFacebook color="#fff" />
          </a>
          <a
            href="http://linkedin.com/company/thopenergy"
            className="hover:opacity-80"
            target="_blank"
            rel="noopener noreferrer"
            alt="Linkedin"
            aria-label="Linkedin"
          >
            <FaLinkedin color="#fff" />
          </a>
          <a
            href="http://instagram.com/thopenergy"
            className="hover:opacity-80"
            target="_blank"
            rel="noopener noreferrer"
            alt="Instagram"
            aria-label="Instagram"
          >
            <img src="/tim/images/insta_icon.svg" alt="Instagram" />
          </a>
        </div>

        <div className="w-full text-white text-center md:text-left text-sm font-normal leading-7">
          <p>
            Copyright 2025 © TIM S/A. <br />
            © Grupo Thopen Energia
            <br />
            Todos os direitos reservados.
          </p>
          <p>
            Contato:{" "}
            <a
              href="mailto:sac@thopenergy.com.br"
              className="text-white hover:underline"
              aria-label="Email"
            >
              sac@thopenergy.com.br
            </a>
          </p>
          <p>
            Whatsapp:{" "}
            <button
              onClick={handleWhatsappClick}
              className="hover:opacity-60"
              aria-label="Whatsapp"
            >
              (11) 4863-3465
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
